// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./components/DatePicker/DatePicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./components/InlineFeedback/InlineFeedback.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `swal-icon--success__ring {
  width: 67px;
  height: 67px;
  border: 4px solid rgba(164, 219, 132, 0.2);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: 2px;
  top: 2px;
  z-index: 2; }

.swal-title {
  color: rgba(0, 0, 0, 0.65);
  font-weight: 500;
  text-transform: none;
  position: relative;
  display: block;
  padding: 13px 16px;
  font-size: 20px;
  line-height: normal;
  text-align: center;
  margin-bottom: 0;
  margin-top: -17px; }

.swal-title:not(:last-child) {
  margin-bottom: 0px; }

span[style*="color: red"],
span[style*="color:red"],
.errMsg,
.err-msg,
.field-error {
  color: var(--danger-default, #c23a2b) !important;
  font-family: var(--font-family-primary, "Lexend", sans-serif) !important;
  font-size: 12px !important;
  line-height: 16px !important;
  margin-top: 4px !important;
  display: block; }

.GoogleInput {
  width: 100%;
  height: 42px;
  border-radius: 0.375rem;
  border: 1px solid #d2d6da;
  padding: 0.75rem; }

.GoogleInput:focus-visible {
  outline-color: #1565c0; }

.centerButton {
  display: flex;
  justify-content: center;
  background-color: green; }

.btn-success:hover {
  background-color: green !important; }

.rdt_TableBody {
  z-index: 0 !important; }

.rdt_TableCol_Sortable div {
  word-wrap: break-word !important;
  white-space: inherit; }

.rdt_TableRow {
  min-height: 35px !important;
  font-size: 12px !important; }
  .rdt_TableRow span {
    word-wrap: break-word !important;
    white-space: normal !important; }
  .rdt_TableRow div {
    word-wrap: break-word !important;
    white-space: normal !important; }

.rdt_Table {
  border: 2px solid;
  border-collapse: collapse; }

.searchButton div {
  padding-right: 0px !important;
  height: 38.11px; }

.buttondata {
  height: 1px !important; }

.MuiTextField-root > .MuiFormLabel-root.Mui-focused {
  color: #000000; }

.MuiCardContent-root {
  padding-bottom: 0px !important;
  padding-left: 16px !important;
  padding-right: 16px !important; }

.rdt_Pagination {
  font-weight: bold !important; }
  .rdt_Pagination button[aria-disabled="false"] {
    font-weight: bold !important; }

.MuiCardContent-root {
  padding-bottom: 0px !important;
  padding-left: 16px !important;
  padding-right: 16px !important; }

.modalButton {
  min-width: 70px !important; }

.checked svg {
  border: 1px solid gray !important; }

.checked .MuiFormControlLabel-label {
  color: #000000 !important; }

#inputTest-label {
  padding-bottom: 2px; }

.or {
  position: relative;
  margin-top: 25px;
  padding: 0 30px; }
  .or p.orText {
    position: absolute;
    background-color: #ffffff;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 5px;
    left: 50%;
    transform: translateX(-50%);
    top: -14px;
    font-weight: 600; }

.socialMedia button:nth-child(1) {
  background-color: #1777f2 !important;
  width: 165px !important;
  font-size: 12px !important;
  font-weight: bold !important;
  font-family: "'Roboto', sans-serif"; }
  .socialMedia button:nth-child(1) span {
    color: #f4f4f4; }

.datePickerValue {
  border: 0px; }

.MuiAutocomplete-inputRoot {
  padding: 1.5px !important; }

.swal-footer {
  text-align: center; }

.swal-title {
  font-size: 18px;
  font-weight: bold;
  padding: 10px 16px;
  margin-top: -11px; }

.swal-icon:first-child {
  margin-top: 10px; }

.swalButtonStyle {
  width: 100%;
  height: 37px;
  border: none;
  border-radius: 10px;
  color: #ffffff;
  font-weight: bold; }

.swal-button.no-button {
  background-color: #6c757d !important;
  color: #ffffff; }

.swal-button.yes-button {
  background-color: #4caf50 !important;
  color: #ffffff; }

.create span svg {
  color: #fff; }

.bgimage {
  background-image: url(https://static-cse.canva.com/blob/1170087/invoicedesignwithsamplesfeaturedimage.da29f5ed.avif);
  height: 100vh;
  width: auto;
  object-fit: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
  overflow-y: scroll; }

.container {
  position: relative; }

.swal-confirm-button {
  position: absolute;
  right: 188px;
  margin-bottom: 16px !important; }

.swal-deny-button {
  background-color: #6c757d !important;
  position: absolute;
  left: 188px;
  margin-bottom: 16px !important; }

.no-button {
  background-color: #6c757d !important;
  color: #ffffff !important; }

.yes-button {
  background-color: #4caf50 !important;
  color: #ffffff !important; }

.red-button {
  background-color: #ff0000 !important;
  color: #ffffff !important; }

.okbutton {
  background-color: #4caf50 !important;
  color: #ffffff !important; }

.okbtnmodel {
  background-color: #4caf50 !important;
  color: #ffffff !important; }

.confirm-button {
  background-color: #4caf50 !important;
  position: absolute;
  right: 188px;
  margin-bottom: 8px !important; }

.deny-button {
  background-color: #6c757d !important;
  position: absolute;
  left: 188px;
  margin-bottom: 8px !important; }

.confirm-buttonss {
  background-color: #4caf50 !important;
  position: absolute;
  right: 188px;
  bottom: 8px; }

.deny-buttonss {
  background-color: #6c757d !important;
  position: absolute;
  left: 170px;
  bottom: 8px;
  width: 61px; }

.swal-button-confirm {
  position: absolute;
  right: 188px;
  top: 230px; }

.swal-button-cancel {
  position: absolute;
  left: 188px;
  top: 230px; }

.swal-button--confirm-green {
  background-color: #4caf50 !important; }

.swal2-popup {
  padding-bottom: 30px; }

.blackLabel {
  color: #000000 !important;
  font-weight: bold; }

.whiteLabel {
  color: white !important;
  font-weight: bold; }

.blackLabel1 {
  background-color: #344467 !important;
  font-weight: bold;
  border: 1px solid #344467;
  color: white; }

.whiteLabel1 {
  background-color: white !important;
  font-weight: bold;
  font-weight: bold;
  color: black; }

.quotationreport {
  width: 372px; }

.darkPopup {
  background-color: var(--surface-elevated, #25282e) !important;
  color: var(--text-primary, #f2f3f5); }

.lightPopup {
  background-color: white !important; }

.darkPopup {
  background-color: var(--surface-elevated, #25282e) !important;
  color: var(--text-primary, #f2f3f5); }

.whitePopup {
  background-color: white !important; }

.swal-title-dark {
  color: white;
  font-size: 18px;
  font-family: Roboto, Helvetica, Arial, sans-serif; }

.swal-title-light {
  color: #545454;
  font-size: 18px;
  font-family: Roboto, Helvetica, Arial, sans-serif; }

.MuiTextField-root {
  color: white !important; }

@media screen and (max-width: 1280px) {
  .gridbuttons {
    display: flex;
    justify-content: center;
    gap: 40px; }
  .addItem {
    position: relative;
    right: 14px; }
  .addItem1 {
    position: relative;
    right: 16px; }
  .addItem2 {
    position: relative;
    right: 12px; }
  .addItem3 {
    position: relative;
    right: 14px; }
  ::-webkit-scrollbar {
    width: 12px;
    height: 20px; }
  ::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.5);
    box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5); }
  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px #c8c9c7; }
  .largeFont1 {
    position: relative;
    right: 10px; }
  .largeFont2 {
    position: relative;
    right: 35px;
    font-size: 14px; }
  .abc {
    position: relative;
    left: 3px; }
  .rdt_TableCol .rdt_TableCol_Sortable {
    white-space: nowrap !important;
    overflow: visible !important; }
    .rdt_TableCol .rdt_TableCol_Sortable div:nth-child(1) {
      white-space: nowrap !important;
      overflow: visible !important; } }

::-webkit-scrollbar {
  width: 12px !important;
  height: 7px !important; }

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.5) !important;
  box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5) !important; }

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px #c8c9c7 !important; }

.swal-button-confirm1 {
  position: absolute;
  right: 188px;
  top: 300px; }

.swal-button-cancel1 {
  position: absolute;
  left: 188px;
  top: 300px; }

.disabledInDarkMode {
  background-color: darkgray !important;
  color: white;
  box-shadow: 0 0 0 darkgray !important; }

.disabledInLightMode {
  background-color: darkgray !important;
  color: white;
  box-shadow: 0 0 0 darkgray !important; }

.crop-image-wrapper {
  height: 400px;
  /* Adjust the height as needed */
  overflow: auto; }

.crop-control {
  position: absolute;
  bottom: 5px;
  left: 15px !important;
  display: flex;
  align-items: center;
  width: 100% !important;
  justify-content: Space-between;
  background: black; }

.cropimgbtn {
  background-color: #4caf50 !important;
  color: #ffffff !important;
  font-size: 12px !important; }

.crop-closebtn {
  background-color: #f58414 !important;
  color: #ffffff !important;
  font-size: 12px !important; }

.swal-button-cancel2 {
  position: absolute;
  left: 188px;
  top: 270px; }

.swal-button-confirm2 {
  position: absolute;
  right: 188px;
  top: 270px; }

.swal-button-cancel3 {
  position: absolute;
  left: 188px;
  top: 250px; }

.swal-button-confirm3 {
  position: absolute;
  right: 188px;
  top: 250px; }

.edit-container .tox-menubar {
  transition: background-color 0.3s, color 0.3s; }

.dark-modes .tox-menubar,
.dark-modes .tox-toolbar__primary,
.dark-modes .tox-statusbar,
.dark-modes .tox-mbtn__select-label,
.dark-modes .tox-tbtn__select-label,
.dark-modes .tox-tbtn__select-chevron svg,
.dark-modes .tox-tbtn__icon-wrap svg path,
.dark-modes .tox-statusbar__path-item,
.dark-modes .tox-statusbar__wordcount,
.dark-modes .tox-statusbar__branding a,
.dark-modes .tox-statusbar__resize-handle g {
  background-color: #222f3e !important;
  color: #fff !important;
  fill: white !important; }

.dark-modes .tox-edit-area__iframe {
  color: #fff !important; }

.dark-modes .tox .tox-mbtn--active {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.dark-modes .tox .tox-mbtn:focus:not(:disabled) {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.dark-modes .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.dark-modes .tox .tox-tbtn:hover {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.dark-modes .tox .tox-tbtn--enabled,
.tox .tox-tbtn--enabled:hover {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.light-modes .tox .tox-mbtn--active {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.light-modes .tox .tox-mbtn:focus:not(:disabled) {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.light-modes .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.light-modes .tox .tox-tbtn:hover {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.light-modes .tox .tox-tbtn--enabled,
.tox .tox-tbtn--enabled:hover {
  background: none;
  border: 0;
  box-shadow: none;
  color: #222f3e; }

.light-modes .tox-menubar,
.light-modes .tox-toolbar__primary,
.light-modes .tox-edit-area__iframe,
.light-modes .tox-statusbar,
.light-modes .tox-mbtn__select-label,
.light-modes .tox-tbtn__select-label,
.light-modes .tox-tbtn__select-chevron svg,
.light-modes .tox-tbtn__icon-wrap svg path,
.light-modes .tox-statusbar__text-container,
.light-modes .tox-statusbar__path-item,
.light-modes .tox-statusbar__wordcount,
.light-modes .tox-statusbar__branding a,
.light-modes .tox-statusbar__resize-handle g {
  background-color: #fff !important;
  color: #222f3e !important; }

.backbtn {
  background-color: #fb8c00 !important;
  padding: 0px 20px !important;
  color: white !important;
  border-radius: 30px !important;
  font-size: 12px !important;
  margin-top: 8px !important; }

.textcontent {
  color: gray !important; }

.large-icon {
  height: 22px !important;
  width: 22px !important; }

.icon-spacing {
  margin-left: 2px; }

.btn-Height {
  height: 44px; }

.dropDownDefaultHighlight {
  font-weight: bold !important;
  color: #1976d2 !important;
  font-size: 14px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding: 4.8px 16px;
  cursor: pointer !important; }

.autoCompleteList {
  color: #424242 !important;
  font-size: 14px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding: 4.8px 16px;
  cursor: pointer !important; }

#demodata {
  padding: 0px !important; }

.darkPopup1 {
  color: whitesmoke !important; }

.whitePopup1 {
  color: #424242 !important; }

.actionicon {
  height: 14px !important;
  width: 14px !important;
  margin-left: 0px !important;
  margin-top: 2px !important; }

.white {
  color: #ffffff !important; }

.black {
  color: #000000 !important; }

.MuiPhoneNumber-flagButton {
  display: block !important; }

.autoCompleteDarkList {
  color: #ffffff !important;
  font-size: 14px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  padding: 4.8px 16px;
  cursor: pointer !important; }

.swal-modal {
  max-width: 100% !important; }

.swal2-modal {
  max-width: 80% !important; }

.addnewbtn {
  height: 38.11px !important; }

.uploadbtn {
  height: 38.11px !important; }

.custom-fieldtext {
  padding: 9px !important; }

.removeExtraPadding div textarea {
  padding-top: 0.5px !important;
  padding-bottom: 0.5px !important; }

body,
select,
option,
svg {
  font-family: "Roboto", sans-serif; }

.MuiBox-root {
  font-size: 12px !important; }

#description {
  height: 11.11px !important; }

.dark-mode {
  background-color: var(--surface-primary, #191b1f) !important;
  color: var(--text-primary, #f2f3f5) !important; }

.dark {
  background-color: var(--bg-primary, #101113) !important;
  color: var(--text-primary, #f2f3f5) !important; }

.white {
  background-color: #ffffff !important;
  color: #000000 !important; }

.dark-modes {
  color: #ffffff !important; }

.white-modes {
  color: #000000 !important; }

.custom-popup-height {
  height: -moz-fit-content !important;
  height: fit-content !important;
  padding-bottom: 20px; }

.darktext {
  color: #267fea !important; }

#demo-simple-select {
  font-size: 12px !important; }

#day-hours-select {
  font-size: 12px !important; }

.swal2-title {
  font-size: 16px !important;
  font-family: "Roboto", sans-serif; }

.swal2-html-container {
  font-size: 14px !important;
  font-family: "Roboto", sans-serif; }

.swal2-styled {
  font-size: 12px !important;
  font-family: "Roboto", sans-serif; }

.MuiDrawer-paper {
  overflow-x: hidden !important; }

::-webkit-scrollbar {
  width: 12px;
  height: 20px; }

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5); }

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px #c8c9c7; }

label {
  margin-top: -3px !important; }

.payableamount {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  padding-left: 11px !important; }

.otp-input-style {
  text-align: center;
  margin: 5px;
  border: 1px solid #ccc;
  border-radius: 4px; }

.not-allowed {
  cursor: not-allowed !important;
  opacity: 0.5;
  pointer-events: none; }

.custom-confirm-button {
  background-color: #4caf50 !important; }

.scroller {
  overflow-y: scroll;
  scrollbar-width: thin; }

input.largerCheckbox {
  width: 25px;
  height: 25px; }

::-webkit-scrollbar {
  width: 12px;
  height: 20px; }

::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.5);
  box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5); }

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 10px #c8c9c7; }

.dialogTitle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: -25px; }

.arrowdropdown {
  height: 25px !important;
  width: 25px !important; }

.contenttxt {
  margin-top: -8px !important;
  font-size: 14px !important; }

.contenttxt1 {
  margin-top: 5px !important;
  font-size: 14px !important; }

.contenttxtDoc {
  margin: 5px 0px !important;
  font-size: 14px !important; }

.txtdata {
  font-size: 14px !important;
  margin-top: 5px !important; }

.descripttxt {
  width: 500px; }

.horizontalend {
  display: flex;
  justify-content: flex-end; }

.horizontalline {
  width: 310px;
  margin-right: 10px;
  margin-top: 10px;
  border-bottom: 2px solid lightgray; }

.arrowdropdown {
  height: 25px !important;
  width: 25px !important; }

.Toastify__progress-bar--rtl {
  animation: Toastify__progress-bar-animation 0.5s linear;
  animation-play-state: paused; }

@keyframes Toastify__progress-bar-animation {
  from {
    transform: scaleX(1); }
  to {
    transform: scaleX(0); } }

.textUnderline {
  text-decoration: underline; }

.dayHour div {
  padding-left: 0px !important; }

.uploadfile {
  height: 35.11px !important; }

.textEmailTo .MuiInputBase-adornedStart {
  flex-wrap: wrap !important; }

.username {
  color: white !important;
  cursor: pointer;
  font-size: 14px !important;
  padding-top: 10px !important; }

.custom-swal {
  max-width: 950px !important;
  margin-top: 20px !important; }

.swal-icon {
  margin-top: 30px !important; }

.swal-text {
  padding-top: 10px !important;
  font-size: 16px !important; }

.ress div input {
  padding-right: 20px !important; }

.abc {
  height: 50px !important; }
`, "",{"version":3,"sources":["webpack://./src/App.scss"],"names":[],"mappings":"AAMA;EACE,WAAW;EACX,YAAY;EACZ,0CAAyC;EACzC,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU,EAAA;;AAGZ;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB,EAAA;;AAyBpB;;;;;EAKE,gDAAgD;EAChD,wEAAwE;EACxE,0BAA0B;EAC1B,4BAA4B;EAC5B,0BAA0B;EAC1B,cAAc,EAAA;;AAGhB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB,EAAA;;AAGlB;EACE,sBAAsB,EAAA;;AAGxB;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB,EAAA;;AAGzB;EACE,kCAAkC,EAAA;;AAOpC;EACE,qBAAqB,EAAA;;AAGvB;EAEI,gCAAgC;EAChC,oBAAoB,EAAA;;AAIxB;EACE,2BAA2B;EAC3B,0BAA0B,EAAA;EAF5B;IAKI,gCAAgC;IAChC,8BAA8B,EAAA;EANlC;IAUI,gCAAgC;IAChC,8BAA8B,EAAA;;AAclC;EACE,iBAAiB;EACjB,yBAAyB,EAAA;;AAG3B;EAEI,6BAA6B;EAC7B,eAAe,EAAA;;AAWnB;EACE,sBAAsB,EAAA;;AAGxB;EACE,cAAc,EAAA;;AAMhB;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B,EAAA;;AAGhC;EAEE,4BAA4B,EAAA;EAF9B;IAQI,4BAA4B,EAAA;;AAIhC;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,8BAA8B,EAAA;;AAGhC;EACE,0BAA0B,EAAA;;AAG5B;EAEI,iCAAiC,EAAA;;AAFrC;EAMI,yBAAyB,EAAA;;AAI7B;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe,EAAA;EAHjB;IAMI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,2BAA2B;IAC3B,UAAU;IACV,gBAAgB,EAAA;;AAIpB;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC,EAAA;EANrC;IAUI,cAAc,EAAA;;AAIlB;EACE,WAAW,EAAA;;AAGb;EACE,yBAAyB,EAAA;;AAG3B;EACE,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB,EAAA;;AAInB;EACE,gBAAgB,EAAA;;AAGlB;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,iBAAiB,EAAA;;AAqBnB;EACE,oCAAoC;EACpC,cAAc,EAAA;;AAGhB;EACE,oCAAoC;EACpC,cAAc,EAAA;;AAGhB;EAGM,WAAW,EAAA;;AAmBjB;EACE,oHAAoH;EACpH,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAWpB;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B,EAAA;;AAGhC;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,8BAA8B,EAAA;;AAGhC;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,6BAA6B,EAAA;;AAG/B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,6BAA6B,EAAA;;AAG/B;EACE,oCAAoC;EACpC,kBAAkB;EAClB,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW,EAAA;;AAGb;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,oCAAoC,EAAA;;AAGtC;EACE,oBAAoB,EAAA;;AAGtB;EACE,yBAAyB;EACzB,iBAAiB,EAAA;;AAGnB;EACE,uBAAuB;EACvB,iBAAiB,EAAA;;AAGnB;EACE,oCAAoC;EACpC,iBAAiB;EACjB,yBAAyB;EACzB,YAAY,EAAA;;AAGd;EACE,kCAAkC;EAClC,iBAAiB;EACjB,iBAAiB;EAEjB,YAAY,EAAA;;AAGd;EACE,YAAY,EAAA;;AAGd;EACE,6DAA6D;EAC7D,mCAAmC,EAAA;;AAGrC;EACE,kCAAkC,EAAA;;AAGpC;EACE,6DAA6D;EAC7D,mCAAmC,EAAA;;AAGrC;EACE,kCAAkC,EAAA;;AAGpC;EACE,YAAY;EACZ,eAAe;EACf,iDAAiD,EAAA;;AAGnD;EACE,cAAc;EACd,eAAe;EACf,iDAAiD,EAAA;;AAGnD;EACE,uBAAuB,EAAA;;AAGzB;EACE;IACE,aAAa;IACb,uBAAuB;IACvB,SAAS,EAAA;EAGX;IACE,kBAAkB;IAClB,WAAW,EAAA;EAGb;IACE,kBAAkB;IAClB,WAAW,EAAA;EAGb;IACE,kBAAkB;IAClB,WAAW,EAAA;EAGb;IACE,kBAAkB;IAClB,WAAW,EAAA;EAGb;IACE,WAAW;IACX,YAAY,EAAA;EAGd;IACE,8BAA8B;IAC9B,kDAAkD,EAAA;EAGpD;IACE,kCAA6C,EAAA;EAG/C;IACE,kBAAkB;IAClB,WAAW,EAAA;EAGb;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe,EAAA;EAGjB;IACE,kBAAkB;IAClB,SAAS,EAAA;EAGX;IAOI,8BAA8B;IAC9B,4BAA4B,EAAA;IARhC;MAGM,8BAA8B;MAC9B,4BAA4B,EAAA,EAC7B;;AAQP;EACE,sBAAsB;EACtB,sBAAsB,EAAA;;AAGxB;EACE,yCAAyC;EACzC,6DAA6D,EAAA;;AAI/D;EACE,6CAAwD,EAAA;;AAG1D;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,qCAAqC;EAErC,YAAY;EACZ,qCAAqC,EAAA;;AAGvC;EACE,qCAAqC;EAErC,YAAY;EACZ,qCAAqC,EAAA;;AAKvC;EACE,aAAa;EACb,gCAAA;EACA,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB,EAAA;;AAGnB;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B,EAAA;;AAG5B;EACE,oCAAoC;EACpC,yBAAyB;EACzB,0BAA0B,EAAA;;AAG5B;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAA;;AAKZ;EACE,6CAA6C,EAAA;;AAG/C;;;;;;;;;;;EAWE,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB,EAAA;;AAGxB;EACE,sBAAsB,EAAA;;AAIxB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;;EAEE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAKhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;;EAEE,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,cAAc,EAAA;;AAGhB;;;;;;;;;;;;;EAaE,iCAAiC;EACjC,yBAAyB,EAAA;;AAK3B;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;EAC1B,0BAA0B,EAAA;;AAG5B;EACE,sBAAsB,EAAA;;AAGxB;EAEE,uBAAuB;EACvB,sBAAsB,EAAA;;AAGxB;EACE,gBAAgB,EAAA;;AAGlB;EACE,YAAY,EAAA;;AAGd;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,eAAe;EACf,uDAAuD;EACvD,mBAAmB;EACnB,0BAA0B,EAAA;;AAG5B;EACE,yBAAyB;EACzB,eAAe;EACf,uDAAuD;EACvD,mBAAmB;EACnB,0BAA0B,EAAA;;AAG5B;EACE,uBAAuB,EAAA;;AAGzB;EACE,4BAA4B,EAAA;;AAG9B;EACE,yBAAyB,EAAA;;AAG3B;EACE,uBAAuB;EACvB,sBAAsB;EACtB,2BAA2B;EAC3B,0BAA0B,EAAA;;AAG5B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB;EACzB,eAAe;EACf,uDAAuD;EACvD,mBAAmB;EACnB,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAK5B;EACE,yBAAyB,EAAA;;AAK3B;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAO5B;EACE,uBAAuB,EAAA;;AAGzB;EAGM,6BAA6B;EAC7B,gCAAgC,EAAA;;AAOtC;;;;EAIE,iCAAiC,EAAA;;AAGnC;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,4DAA4D;EAC5D,8CAA8C,EAAA;;AAchD;EACE,uDAAuD;EACvD,8CAA8C,EAAA;;AAGhD;EACE,oCAAoC;EACpC,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,yBAAyB,EAAA;;AAG3B;EACE,mCAA8B;EAA9B,8BAA8B;EAC9B,oBAAoB,EAAA;;AAGtB;EACE,yBAAyB,EAAA;;AAI3B;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B;EAC1B,iCAAiC,EAAA;;AAGnC;EACE,0BAA0B;EAC1B,iCAAiC,EAAA;;AAGnC;EACE,0BAA0B;EAC1B,iCAAiC,EAAA;;AAGnC;EACE,6BAA6B,EAAA;;AAG/B;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,8BAA8B;EAC9B,kDAAkD,EAAA;;AAGpD;EACE,kCAA6C,EAAA;;AAG/C;EACE,2BAA2B,EAAA;;AAG7B;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,6BAA6B,EAAA;;AAG/B;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kBAAkB,EAAA;;AAGpB;EACE,8BAA8B;EAC9B,YAAY;EACZ,oBAAoB,EAAA;;AAGtB;EACE,oCAAoC,EAAA;;AAGtC;EACE,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,WAAW;EACX,YAAY,EAAA;;AAGd;EACE,8BAA8B;EAC9B,kDAAkD,EAAA;;AAGpD;EACE,kCAA6C,EAAA;;AAG/C;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB,EAAA;;AAGnB;EACE,uBAAuB;EACvB,sBAAsB,EAAA;;AAMxB;EACE,2BAA2B;EAC3B,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B;EAC1B,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B;EAC1B,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B;EAC1B,0BAA0B,EAAA;;AAG5B;EACE,YAAY,EAAA;;AAGd;EACE,aAAa;EACb,yBAAyB,EAAA;;AAG3B;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC,EAAA;;AAGpC;EACE,uBAAuB;EACvB,sBAAsB,EAAA;;AAGxB;EACE,uDAAuD;EACvD,4BAA4B,EAAA;;AAG9B;EACE;IACE,oBAAoB,EAAA;EAGtB;IACE,oBAAoB,EAAA,EAAA;;AAIxB;EACE,0BAA0B,EAAA;;AAO5B;EAEI,4BAA4B,EAAA;;AAIhC;EACE,0BAA0B,EAAA;;AAG5B;EAEI,0BAA0B,EAAA;;AAI9B;EACE,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,4BAA4B,EAAA;;AAG9B;EACE,2BAA2B;EAC3B,2BAA2B,EAAA;;AAI7B;EACE,2BAA2B,EAAA;;AAG7B;EACE,4BAA4B;EAC5B,0BAA0B,EAAA;;AAE5B;EAGM,8BAA8B,EAAA;;AAIpC;EACE,uBAAuB,EAAA","sourcesContent":["// .swal-modal {\n//   width: 500px;\n//   height: auto;\n//   // padding-bottom: 40px;\n// }\n\nswal-icon--success__ring {\n  width: 67px;\n  height: 67px;\n  border: 4px solid hsla(98, 55%, 69%, 0.2);\n  border-radius: 50%;\n  box-sizing: content-box;\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  z-index: 2;\n}\n\n.swal-title {\n  color: rgba(0, 0, 0, 0.65);\n  font-weight: 500;\n  text-transform: none;\n  position: relative;\n  display: block;\n  padding: 13px 16px;\n  font-size: 20px;\n  line-height: normal;\n  text-align: center;\n  margin-bottom: 0;\n  margin-top: -17px;\n}\n\n.swal-title:not(:last-child) {\n  margin-bottom: 0px;\n}\n\n// .react-datepicker__input-container {\n//   display: block;\n//   width: 100%;\n// }\n\n// .react-datepicker__input-container input {\n//   height:44px;\n//   font-size: 16px;\n//   border-radius: 4px;\n//   // border: 1px solid #d3d3d3;\n//   padding: 8px 12px;\n//   box-sizing: border-box;\n//   // width: 100%;\n// }\n\n// Figma Datepicker Design System styles\n@import \"./components/DatePicker/DatePicker.css\";\n\n// Figma Inline Feedback & Button Loading styles\n@import \"./components/InlineFeedback/InlineFeedback.css\";\n\n// Global Field Validation styling matching Figma Node 1012:77514\nspan[style*=\"color: red\"],\nspan[style*=\"color:red\"],\n.errMsg,\n.err-msg,\n.field-error {\n  color: var(--danger-default, #c23a2b) !important;\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif) !important;\n  font-size: 12px !important;\n  line-height: 16px !important;\n  margin-top: 4px !important;\n  display: block;\n}\n\n.GoogleInput {\n  width: 100%;\n  height: 42px;\n  border-radius: 0.375rem;\n  border: 1px solid #d2d6da;\n  padding: 0.75rem;\n}\n\n.GoogleInput:focus-visible {\n  outline-color: #1565c0;\n}\n\n.centerButton {\n  display: flex;\n  justify-content: center;\n  background-color: green;\n}\n\n.btn-success:hover {\n  background-color: green !important;\n}\n\n// .MuiOutlinedInput-input[disabled] {\n//   color: red;\n// }\n\n.rdt_TableBody {\n  z-index: 0 !important;\n}\n\n.rdt_TableCol_Sortable {\n  div {\n    word-wrap: break-word !important;\n    white-space: inherit;\n  }\n}\n\n.rdt_TableRow {\n  min-height: 35px !important;\n  font-size: 12px !important;\n\n  span {\n    word-wrap: break-word !important;\n    white-space: normal !important;\n  }\n\n  div {\n    word-wrap: break-word !important;\n    white-space: normal !important;\n  }\n}\n\n// .rdt_TableRow:nth-child(even){\n//   background: #e8e9e8 !important;\n//   cursor: pointer;\n// }\n\n// .rdt_TableRow:nth-child(odd):hover{\n//    background: #f5f5f5 !important;\n//    cursor: pointer;\n// }\n\n.rdt_Table {\n  border: 2px solid;\n  border-collapse: collapse;\n}\n\n.searchButton {\n  div {\n    padding-right: 0px !important;\n    height: 38.11px;\n  }\n\n  // input {\n  //   padding: 11px;\n  // }\n  // button {\n  //   padding: 5px !important;\n  // }\n}\n\n.buttondata {\n  height: 1px !important;\n}\n\n.MuiTextField-root > .MuiFormLabel-root.Mui-focused {\n  color: #000000;\n}\n\n// .MuiOutlinedInput-notchedOutline{\n//   border-color: #000000 !important;\n// }\n.MuiCardContent-root {\n  padding-bottom: 0px !important;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n.rdt_Pagination {\n  // getElementsByTagName('span')[0].textContent = \"Records Per Page\"\n  font-weight: bold !important;\n  // color: #000000 !important;\n\n  button[aria-disabled=\"false\"] {\n    // fill: #000000 !important;\n    // color: #000000 !important;\n    font-weight: bold !important;\n  }\n}\n\n.MuiCardContent-root {\n  padding-bottom: 0px !important;\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n\n.modalButton {\n  min-width: 70px !important;\n}\n\n.checked {\n  svg {\n    border: 1px solid gray !important;\n  }\n\n  .MuiFormControlLabel-label {\n    color: #000000 !important;\n  }\n}\n\n#inputTest-label {\n  padding-bottom: 2px;\n}\n\n.or {\n  position: relative;\n  margin-top: 25px;\n  padding: 0 30px;\n\n  p.orText {\n    position: absolute;\n    background-color: #ffffff;\n    padding-left: 10px;\n    padding-right: 10px;\n    padding-top: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n    top: -14px;\n    font-weight: 600;\n  }\n}\n\n.socialMedia button:nth-child(1) {\n  // color: red !important;\n  background-color: #1777f2 !important;\n  width: 165px !important;\n  font-size: 12px !important;\n  font-weight: bold !important;\n  font-family: \"'Roboto', sans-serif\";\n\n  // width: 180px  !important;\n  span {\n    color: #f4f4f4;\n  }\n}\n\n.datePickerValue {\n  border: 0px;\n}\n\n.MuiAutocomplete-inputRoot {\n  padding: 1.5px !important;\n}\n\n.swal-footer {\n  text-align: center;\n}\n\n.swal-title {\n  font-size: 18px;\n  font-weight: bold;\n  padding: 10px 16px;\n  margin-top: -11px;\n  // box-sizing: border-box;\n}\n\n.swal-icon:first-child {\n  margin-top: 10px;\n}\n\n.swalButtonStyle {\n  width: 100%;\n  height: 37px;\n  border: none;\n  border-radius: 10px;\n  color: #ffffff;\n  font-weight: bold;\n}\n\n// .btn-warning {\n//   color: #ffffff;\n//   background: #D3D3D3;\n// }\n// .btn-success {\n//   color: #ffffff;\n//   background: #5BB947;\n// }\n\n// .button{\n//   color:\"#ffffff\";\n//   background: #D3D3D3;\n// }\n// .button1{\n//   color:\"#ffffff\";\n//   background:#5BB947;\n// }\n\n.swal-button.no-button {\n  background-color: #6c757d !important;\n  color: #ffffff;\n}\n\n.swal-button.yes-button {\n  background-color: #4caf50 !important;\n  color: #ffffff;\n}\n\n.create {\n  span {\n    svg {\n      color: #fff;\n    }\n  }\n}\n\n// .swal-button:hover {\n//   filter: brightness(0.1);\n// }\n\n// wizard backgroundimage\n// .bgimage {\n//   background-image: url(https://static-cse.canva.com/blob/1170087/invoicedesignwithsamplesfeaturedimage.da29f5ed.avif);\n//   height: 100vh;\n//   width: auto;\n//   object-fit: cover;\n//   background-repeat: no-repeat;\n//   background-position: center;\n// }\n\n.bgimage {\n  background-image: url(https://static-cse.canva.com/blob/1170087/invoicedesignwithsamplesfeaturedimage.da29f5ed.avif);\n  height: 100vh;\n  width: auto;\n  object-fit: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  overflow: hidden;\n  overflow-y: scroll;\n}\n\n.container {\n  position: relative;\n}\n\n// .center {\n//   position: absolute;\n//   top: -14%;\n//   width: 100%;\n//   text-align: center;\n//   font-size: 18px;\n// }\n\n.swal-confirm-button {\n  position: absolute;\n  right: 188px;\n  margin-bottom: 16px !important;\n}\n\n.swal-deny-button {\n  background-color: #6c757d !important;\n  position: absolute;\n  left: 188px;\n  margin-bottom: 16px !important;\n}\n\n.no-button {\n  background-color: #6c757d !important;\n  color: #ffffff !important;\n}\n\n.yes-button {\n  background-color: #4caf50 !important;\n  color: #ffffff !important;\n}\n\n.red-button {\n  background-color: #ff0000 !important;\n  color: #ffffff !important;\n}\n\n.okbutton {\n  background-color: #4caf50 !important;\n  color: #ffffff !important;\n}\n\n.okbtnmodel {\n  background-color: #4caf50 !important;\n  color: #ffffff !important;\n}\n\n.confirm-button {\n  background-color: #4caf50 !important;\n  position: absolute;\n  right: 188px;\n  margin-bottom: 8px !important;\n}\n\n.deny-button {\n  background-color: #6c757d !important;\n  position: absolute;\n  left: 188px;\n  margin-bottom: 8px !important;\n}\n\n.confirm-buttonss {\n  background-color: #4caf50 !important;\n  position: absolute;\n  right: 188px;\n  bottom: 8px;\n}\n\n.deny-buttonss {\n  background-color: #6c757d !important;\n  position: absolute;\n  left: 170px;\n  bottom: 8px;\n  width: 61px;\n}\n\n.swal-button-confirm {\n  position: absolute;\n  right: 188px;\n  top: 230px;\n}\n\n.swal-button-cancel {\n  position: absolute;\n  left: 188px;\n  top: 230px;\n}\n\n.swal-button--confirm-green {\n  background-color: #4caf50 !important;\n}\n\n.swal2-popup {\n  padding-bottom: 30px;\n}\n\n.blackLabel {\n  color: #000000 !important;\n  font-weight: bold;\n}\n\n.whiteLabel {\n  color: white !important;\n  font-weight: bold;\n}\n\n.blackLabel1 {\n  background-color: #344467 !important;\n  font-weight: bold;\n  border: 1px solid #344467;\n  color: white;\n}\n\n.whiteLabel1 {\n  background-color: white !important;\n  font-weight: bold;\n  font-weight: bold;\n  // border:1px solid black;\n  color: black;\n}\n\n.quotationreport {\n  width: 372px;\n}\n\n.darkPopup {\n  background-color: var(--surface-elevated, #25282e) !important;\n  color: var(--text-primary, #f2f3f5);\n}\n\n.lightPopup {\n  background-color: white !important;\n}\n\n.darkPopup {\n  background-color: var(--surface-elevated, #25282e) !important;\n  color: var(--text-primary, #f2f3f5);\n}\n\n.whitePopup {\n  background-color: white !important;\n}\n\n.swal-title-dark {\n  color: white;\n  font-size: 18px;\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n}\n\n.swal-title-light {\n  color: #545454;\n  font-size: 18px;\n  font-family: Roboto, Helvetica, Arial, sans-serif;\n}\n\n.MuiTextField-root {\n  color: white !important;\n}\n\n@media screen and (max-width: 1280px) {\n  .gridbuttons {\n    display: flex;\n    justify-content: center;\n    gap: 40px;\n  }\n\n  .addItem {\n    position: relative;\n    right: 14px;\n  }\n\n  .addItem1 {\n    position: relative;\n    right: 16px;\n  }\n\n  .addItem2 {\n    position: relative;\n    right: 12px;\n  }\n\n  .addItem3 {\n    position: relative;\n    right: 14px;\n  }\n\n  ::-webkit-scrollbar {\n    width: 12px;\n    height: 20px;\n  }\n\n  ::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.5);\n    box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5);\n  }\n\n  ::-webkit-scrollbar-track {\n    box-shadow: inset 0 0 10px rgb(200, 201, 199);\n  }\n\n  .largeFont1 {\n    position: relative;\n    right: 10px;\n  }\n\n  .largeFont2 {\n    position: relative;\n    right: 35px;\n    font-size: 14px;\n  }\n\n  .abc {\n    position: relative;\n    left: 3px;\n  }\n\n  .rdt_TableCol {\n    .rdt_TableCol_Sortable {\n      div:nth-child(1) {\n        white-space: nowrap !important;\n        overflow: visible !important;\n      }\n\n      white-space: nowrap !important;\n      overflow: visible !important;\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  width: 12px !important;\n  height: 7px !important;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.5) !important;\n  box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5) !important;\n  // background: rgba(116, 212, 206, 0.5) !important;\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 10px rgb(200, 201, 199) !important;\n}\n\n.swal-button-confirm1 {\n  position: absolute;\n  right: 188px;\n  top: 300px;\n}\n\n.swal-button-cancel1 {\n  position: absolute;\n  left: 188px;\n  top: 300px;\n}\n\n.disabledInDarkMode {\n  background-color: darkgray !important;\n  // cursor: not-allowed !important;\n  color: white;\n  box-shadow: 0 0 0 darkgray !important;\n}\n\n.disabledInLightMode {\n  background-color: darkgray !important;\n  // cursor: not-allowed !important;\n  color: white;\n  box-shadow: 0 0 0 darkgray !important;\n}\n\n//\n\n.crop-image-wrapper {\n  height: 400px;\n  /* Adjust the height as needed */\n  overflow: auto;\n}\n\n.crop-control {\n  position: absolute;\n  bottom: 5px;\n  left: 15px !important;\n  display: flex;\n  align-items: center;\n  width: 100% !important;\n  justify-content: Space-between;\n  background: black;\n}\n\n.cropimgbtn {\n  background-color: #4caf50 !important;\n  color: #ffffff !important;\n  font-size: 12px !important;\n}\n\n.crop-closebtn {\n  background-color: #f58414 !important;\n  color: #ffffff !important;\n  font-size: 12px !important;\n}\n\n.swal-button-cancel2 {\n  position: absolute;\n  left: 188px;\n  top: 270px;\n}\n\n.swal-button-confirm2 {\n  position: absolute;\n  right: 188px;\n  top: 270px;\n}\n\n.swal-button-cancel3 {\n  position: absolute;\n  left: 188px;\n  top: 250px;\n}\n\n.swal-button-confirm3 {\n  position: absolute;\n  right: 188px;\n  top: 250px;\n}\n\n// Editor CSS\n\n.edit-container .tox-menubar {\n  transition: background-color 0.3s, color 0.3s;\n}\n\n.dark-modes .tox-menubar,\n.dark-modes .tox-toolbar__primary,\n.dark-modes .tox-statusbar,\n.dark-modes .tox-mbtn__select-label,\n.dark-modes .tox-tbtn__select-label,\n.dark-modes .tox-tbtn__select-chevron svg,\n.dark-modes .tox-tbtn__icon-wrap svg path,\n.dark-modes .tox-statusbar__path-item,\n.dark-modes .tox-statusbar__wordcount,\n.dark-modes .tox-statusbar__branding a,\n.dark-modes .tox-statusbar__resize-handle g {\n  background-color: #222f3e !important;\n  color: #fff !important;\n  fill: white !important;\n}\n\n.dark-modes .tox-edit-area__iframe {\n  color: #fff !important;\n  // background-color: #222F3E !important;\n}\n\n.dark-modes .tox .tox-mbtn--active {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.dark-modes .tox .tox-mbtn:focus:not(:disabled) {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.dark-modes .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.dark-modes .tox .tox-tbtn:hover {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.dark-modes .tox .tox-tbtn--enabled,\n.tox .tox-tbtn--enabled:hover {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n// lightmode\n\n.light-modes .tox .tox-mbtn--active {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.light-modes .tox .tox-mbtn:focus:not(:disabled) {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.light-modes .tox .tox-mbtn:hover:not(:disabled):not(.tox-mbtn--active) {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.light-modes .tox .tox-tbtn:hover {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.light-modes .tox .tox-tbtn--enabled,\n.tox .tox-tbtn--enabled:hover {\n  background: none;\n  border: 0;\n  box-shadow: none;\n  color: #222f3e;\n}\n\n.light-modes .tox-menubar,\n.light-modes .tox-toolbar__primary,\n.light-modes .tox-edit-area__iframe,\n.light-modes .tox-statusbar,\n.light-modes .tox-mbtn__select-label,\n.light-modes .tox-tbtn__select-label,\n.light-modes .tox-tbtn__select-chevron svg,\n.light-modes .tox-tbtn__icon-wrap svg path,\n.light-modes .tox-statusbar__text-container,\n.light-modes .tox-statusbar__path-item,\n.light-modes .tox-statusbar__wordcount,\n.light-modes .tox-statusbar__branding a,\n.light-modes .tox-statusbar__resize-handle g {\n  background-color: #fff !important;\n  color: #222f3e !important;\n}\n\n// --------------------------------------\n\n.backbtn {\n  background-color: #fb8c00 !important;\n  padding: 0px 20px !important;\n  color: white !important;\n  border-radius: 30px !important;\n  font-size: 12px !important;\n  margin-top: 8px !important;\n}\n\n.textcontent {\n  color: gray !important;\n}\n\n.large-icon {\n  // font-size: 40px !important;\n  height: 22px !important;\n  width: 22px !important;\n}\n\n.icon-spacing {\n  margin-left: 2px;\n}\n\n.btn-Height {\n  height: 44px;\n}\n\n.dropDownDefaultHighlight {\n  font-weight: bold !important;\n  color: #1976d2 !important;\n  font-size: 14px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  padding: 4.8px 16px;\n  cursor: pointer !important;\n}\n\n.autoCompleteList {\n  color: #424242 !important;\n  font-size: 14px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  padding: 4.8px 16px;\n  cursor: pointer !important;\n}\n\n#demodata {\n  padding: 0px !important;\n}\n\n.darkPopup1 {\n  color: whitesmoke !important;\n}\n\n.whitePopup1 {\n  color: #424242 !important;\n}\n\n.actionicon {\n  height: 14px !important;\n  width: 14px !important;\n  margin-left: 0px !important;\n  margin-top: 2px !important;\n}\n\n.white {\n  color: #ffffff !important;\n}\n\n.black {\n  color: #000000 !important;\n}\n\n.MuiPhoneNumber-flagButton {\n  display: block !important;\n}\n\n.autoCompleteDarkList {\n  color: #ffffff !important;\n  font-size: 14px;\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\n  padding: 4.8px 16px;\n  cursor: pointer !important;\n}\n\n.swal-modal {\n  max-width: 100% !important;\n\n  // width: auto !important;\n}\n\n.swal2-modal {\n  max-width: 80% !important;\n  // max-height: 65% !important;\n  // width: auto !important;\n}\n\n.addnewbtn {\n  height: 38.11px !important;\n}\n\n.uploadbtn {\n  height: 38.11px !important;\n}\n\n// .MuiInputBase-input {\n//  padding: 9px  !important;\n// }\n\n.custom-fieldtext {\n  padding: 9px !important;\n}\n\n.removeExtraPadding {\n  div {\n    textarea {\n      padding-top: 0.5px !important;\n      padding-bottom: 0.5px !important;\n      // padding-left: 9px !important;\n      // padding-right: 9px !important;\n    }\n  }\n}\n\nbody,\nselect,\noption,\nsvg {\n  font-family: \"Roboto\", sans-serif;\n}\n\n.MuiBox-root {\n  font-size: 12px !important;\n}\n\n#description {\n  height: 11.11px !important;\n}\n\n.dark-mode {\n  background-color: var(--surface-primary, #191b1f) !important;\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n// .MuiGrid-item {\n//   padding-top: 14px !important;\n// }\n\n// .MuiTypography-h4{\n//   font-size: 12px !important;\n// }\n// .MuiTypography-button{\n//   font-size: 12px !important;\n// }\n\n.dark {\n  background-color: var(--bg-primary, #101113) !important;\n  color: var(--text-primary, #f2f3f5) !important;\n}\n\n.white {\n  background-color: #ffffff !important;\n  color: #000000 !important;\n}\n\n.dark-modes {\n  color: #ffffff !important;\n}\n\n.white-modes {\n  color: #000000 !important;\n}\n\n.custom-popup-height {\n  height: fit-content !important;\n  padding-bottom: 20px;\n}\n\n.darktext {\n  color: #267fea !important;\n  // color:linear-gradient(195deg, #3198e7, #1ed6ca);\n}\n\n#demo-simple-select {\n  font-size: 12px !important;\n}\n\n#day-hours-select {\n  font-size: 12px !important;\n}\n\n.swal2-title {\n  font-size: 16px !important;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.swal2-html-container {\n  font-size: 14px !important;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.swal2-styled {\n  font-size: 12px !important;\n  font-family: \"Roboto\", sans-serif;\n}\n\n.MuiDrawer-paper {\n  overflow-x: hidden !important;\n}\n\n::-webkit-scrollbar {\n  width: 12px;\n  height: 20px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.5);\n  box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5);\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 10px rgb(200, 201, 199);\n}\n\nlabel {\n  margin-top: -3px !important;\n}\n\n.payableamount {\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  padding-left: 11px !important;\n}\n\n.otp-input-style {\n  text-align: center;\n  margin: 5px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n}\n\n.not-allowed {\n  cursor: not-allowed !important;\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.custom-confirm-button {\n  background-color: #4caf50 !important;\n}\n\n.scroller {\n  overflow-y: scroll;\n  scrollbar-width: thin;\n}\n\ninput.largerCheckbox {\n  width: 25px;\n  height: 25px;\n}\n\n::-webkit-scrollbar {\n  width: 12px;\n  height: 20px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.5);\n  box-shadow: inset 0 0 6px rgba(255, 208, 208, 0.5);\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 10px rgb(200, 201, 199);\n}\n\n.dialogTitle {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: -25px;\n}\n\n.arrowdropdown {\n  height: 25px !important;\n  width: 25px !important;\n}\n\n//   margin-top: -25px !important;\n//   font-size: 16px !important;\n// }\n.contenttxt {\n  margin-top: -8px !important;\n  font-size: 14px !important;\n}\n\n.contenttxt1 {\n  margin-top: 5px !important;\n  font-size: 14px !important;\n}\n\n.contenttxtDoc {\n  margin: 5px 0px !important;\n  font-size: 14px !important;\n}\n\n.txtdata {\n  font-size: 14px !important;\n  margin-top: 5px !important;\n}\n\n.descripttxt {\n  width: 500px;\n}\n\n.horizontalend {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.horizontalline {\n  width: 310px;\n  margin-right: 10px;\n  margin-top: 10px;\n  border-bottom: 2px solid lightgray;\n}\n\n.arrowdropdown {\n  height: 25px !important;\n  width: 25px !important;\n}\n\n.Toastify__progress-bar--rtl {\n  animation: Toastify__progress-bar-animation 0.5s linear;\n  animation-play-state: paused;\n}\n\n@keyframes Toastify__progress-bar-animation {\n  from {\n    transform: scaleX(1);\n  }\n\n  to {\n    transform: scaleX(0);\n  }\n}\n\n.textUnderline {\n  text-decoration: underline;\n}\n\n// .MuiOutlinedInput-input {\n//   height: 17px !important;\n// }\n\n.dayHour {\n  div {\n    padding-left: 0px !important;\n  }\n}\n\n.uploadfile {\n  height: 35.11px !important;\n}\n\n.textEmailTo {\n  .MuiInputBase-adornedStart {\n    flex-wrap: wrap !important;\n  }\n}\n\n.username {\n  color: white !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  padding-top: 10px !important;\n}\n\n.custom-swal {\n  max-width: 950px !important;\n  margin-top: 20px !important;\n  //  padding-bottom:15vh;\n}\n\n.swal-icon {\n  margin-top: 30px !important;\n}\n\n.swal-text {\n  padding-top: 10px !important;\n  font-size: 16px !important;\n}\n.ress {\n  div {\n    input {\n      padding-right: 20px !important;\n    }\n  }\n}\n.abc {\n  height: 50px !important;\n}\n// .custom-fieldtextabc {\n//   height: 200px;\n// }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
